import { STATUS_MAP } from "./utils";

interface StatusPillProps {
    status: number;
    compact?: boolean;
    t: (key: string) => string;
}

const StatusPill = ({ status, compact = false, t }: StatusPillProps) => {
    const config = STATUS_MAP[status];
    if (!config) return null;

    if (compact) {
        return <span className={`status-dot status-dot--large status-dot--${config.status}`} />;
    }

    return (
        <span className={`status-pill status-pill--${config.status}`}>
            <span className={`status-dot status-dot--small status-dot--${config.status}`} />
            {t(config.label)}
        </span>
    );
};

export default StatusPill;
